import React, { useEffect, useState } from 'react'
import { Panel } from 'rsuite'
import QualificationResponsinatorTable from './QualificationResponsinatorTable'

export default function QualificationResponsinatorWidget({
  honorificOptions,
  schema,
  isEditAll,
  ...props
}) {
  const [formSchema, setFormSchema] = useState(schema)

  useEffect(() => {
    if (schema) {
      setFormSchema(schema)
    }
  }, [schema])

  return (
    <>
      {formSchema && (
        <Panel
          header={formSchema.header}
          bordered
          collapsible
          defaultExpanded
          style={{ marginTop: 20 }}
        >
          <>
            <p>{`ระบุข้อมูลโครงการ/งานในความรับผิดชอบที่อยู่ระหว่างดำเนินการทั้งของ สสส. และหน่วยงานอื่นๆ`}</p>
            <br />
            {formSchema && <QualificationResponsinatorTable schema={formSchema} />}
          </>
        </Panel>
      )}
    </>
  )
}
